import { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';

import Home from './pages/Home';
import ServiceDetail from './pages/ServiceDetail';
import ProjectsOverview from './pages/ProjectsOverview';
import ProjectDetail from './pages/ProjectDetail';
import GalleryPage from './pages/GalleryPage';
import AboutUsPage from './pages/AboutUsPage';
import ProjectDevelopmentPage from './pages/ProjectDevelopmentPage';
import ContactPage from './pages/ContactPage';
import JobsPage from './pages/JobsPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

// Scroll Restoration component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-stone-50 font-sans text-stone-900 selection:bg-amber-500 selection:text-stone-950">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ydelser" element={<Navigate to="/ydelser/tagarbejde" replace />} />
            <Route path="/ydelser/:slug" element={<ServiceDetail />} />
            <Route path="/projekter" element={<ProjectsOverview />} />
            <Route path="/projekter/:slug" element={<ProjectDetail />} />
            <Route path="/projektudvikling" element={<ProjectDevelopmentPage />} />
            <Route path="/projekt-udvikling" element={<Navigate to="/projektudvikling" replace />} />
            <Route path="/galleri" element={<GalleryPage />} />
            <Route path="/om-os" element={<AboutUsPage />} />
            <Route path="/ledige-stillinger" element={<JobsPage />} />
            <Route path="/karriere" element={<Navigate to="/ledige-stillinger" replace />} />
            <Route path="/job" element={<Navigate to="/ledige-stillinger" replace />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}
